import { Fragment, useEffect } from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { useSelector, useDispatch } from "react-redux";

import NavBar from "./Components/NavBar";
import SearchArea from "./Components/SearchArea";
import FiltersCard from "./Components/FiltersCard";
import UnendorsedToggle from "./Components/UnendorsedToggle";
import StagingInfo from "./Components/StagingInfo";
import TableWithPaginator from "./Components/TableWithPaginator";
import CustomSnackbar from "./Components/CustomSnackbar";

import config from "./config.json";

const {
  tableSettings,
  dataSettings,
  paginatorSettings,
  categoricalColumns,
  searchSettings,
} = config;

const { fieldsToSearch } = searchSettings;

function App() {
  const pageNumber = useSelector((state) => state.pageNumber);
  const filteredData = useSelector((state) => state.filteredData);
  const numResultsPerPage = useSelector((state) => state.numResultsPerPage);
  const includeUnsurfacedVariables = useSelector(
    (state) => state.includeUnsurfacedVariables
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "CHECK_FOR_SEARCH_RESULTS_IN_URL" });
    dispatch({ type: "UPDATE_FILTERED_IDS_BASED_ON_SEARCH_BOX" });
    dispatch({ type: "UPDATE_FILTERED_IDS_BASED_ON_CHECKBOX" });

    dispatch({ type: "UPDATE_FILTERED_DATA" });
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET_STAGING_AREA" });
  }, [filteredData]);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleUnendorsedChange = () => {
    dispatch({ type: "TOGGLE_INCLUDE_UNSURFACED_VARIABLES_SWITCH" });
    dispatch({ type: "UPDATE_FILTERED_IDS_BASED_ON_SEARCH_BOX" });
    dispatch({ type: "UPDATE_FILTERED_IDS_BASED_ON_CHECKBOX" });
    dispatch({ type: "UPDATE_FILTERED_IDS_BASED_ON_PRECISION_SEARCH" });
    dispatch({ type: "UPDATE_FILTERED_DATA" });
    dispatch({ type: "SET_PAGE_NUMBER", payload: 1 });
  };

  return (
    <Fragment>
      <NavBar></NavBar>
      <Box sx={{ flexGrow: 1, m: 1 }}>
        <Container maxWidth="lg">
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Stack spacing={1}>
                <Box sx={{ height: "35px" }}></Box>
                <SearchArea
                  fieldsToSearch={fieldsToSearch}
                  dataSettings={dataSettings}
                ></SearchArea>
                <FiltersCard
                  dataSettings={dataSettings}
                  categoricalColumns={categoricalColumns}
                ></FiltersCard>
                <UnendorsedToggle
                  includeUnsurfacedVariables={includeUnsurfacedVariables}
                  handleUnendorsedChange={handleUnendorsedChange}
                ></UnendorsedToggle>
              </Stack>
            </Grid>
            <Grid item xs={9}>
              <Stack>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    alignContent: "center",
                    alignItems: "center",
                    marginTop: 0.42,
                  }}
                >
                  <StagingInfo></StagingInfo>
                </Box>
                <TableWithPaginator
                  data={filteredData}
                  tableSettings={tableSettings}
                  dataSettings={dataSettings}
                  paginatorSettings={paginatorSettings}
                  pageNumber={pageNumber}
                  numResultsPerPage={numResultsPerPage}
                ></TableWithPaginator>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <CustomSnackbar></CustomSnackbar>
    </Fragment>
  );
}

export default App;
